import type { Notification } from 'types/common/notification';

const unknownError: Notification = { id: 'api/unknownError', type: 'error', content: 'An unfortunate error occured. Our support has been notified.' };
const unAuthorizedError: Notification = { id: 'api/unAuthorizedError', type: 'error', content: 'You are not logged in anymore.' };

const NOTIFICATION_API = { unknownError, unAuthorizedError };

export default NOTIFICATION_API;
